import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const AppointmentSlotContext = createContext();

export default function AppointmentSlotProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();

  const [currentAppointmentSlots, setAppointmentSlots] = useState([]);

  const updateAppointmentSlots = async () => {
    logger.debug(
      "AppointmentSlotProvider.updateAppointmentSlots",
      `GET field/WIPrefTimeSlots`
    );
    try {
      const data = await auth.get(encodeURI(`field/WIPrefTimeSlots`));

      logger.debug(
        "AppointmentSlotProvider.updateAppointmentSlots",
        `Retrieved data`
      );

      const sortedData = data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });

      setAppointmentSlots(sortedData);
      return sortedData;
    } catch (error) {
      logger.debug(
        "AppointmentSlotProvider.updateAppointmentSlots",
        `Failed to retrieve data`
      );
      setAppointmentSlots([]);
      return [];
    }
  };

  const getAppointmentSlots = () => currentAppointmentSlots;

  return (
    <AppointmentSlotContext.Provider
      value={{
        getAppointmentSlots,
        updateAppointmentSlots,
      }}
    >
      {children}
    </AppointmentSlotContext.Provider>
  );
}

AppointmentSlotProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAppointmentSlots = () => useContext(AppointmentSlotContext);
